'use strict'

const rmCampaign = angular.module('rmCampaign', [])

const isZero = num => num === 0

rmCampaign.filter('fixLastCampaignDay', () => input => {
    const inputDate = new Date(input)

    if (isZero(inputDate.getHours()) &&
        isZero(inputDate.getMinutes()) &&
        isZero(inputDate.getSeconds()) &&
        isZero(inputDate.getMilliseconds())
    ) {
        inputDate.setDate(inputDate.getDate() - 1)
    }

    return inputDate.toISOString()
})

require('./controller')
require('./resources')
require('./directives')
require('./routes')
require('./services')
